export const SET_STATS = 'SET_STATS'
export const FETCH_STATS = 'FETCH_STATS'
